module.exports = __webpack_public_path__ + "img/settings-gear-svgrepo-com.0caaacdf.svg";